<template>
  <div id="passcode-setting" class="rounded-item shadow-md">
    <vs-prompt
      @cancel="cancelAlert"
      @accept="acceptAlert"
      :active.sync="activePrompt"
      type="confirm"
      title="Passcode"
    >
      <div class="con-exemple-prompt">
        Enter the security code
        <vs-input
          placeholder="Code"
          v-model="passcode"
          type="password"
          class="passcode-input w-full"
          @keyup.enter="acceptAlert"
          @input="validate"
        />
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="webAdminCancelAlert"
      @accept="webAdminAcceptAlert"
      :active.sync="webAdminActivePrompt"
      type="confirm"
      title="Passcode"
    >
      <div class="con-exemple-prompt">
        Enter the security code
        <vs-input
          placeholder="Code"
          v-model="passcode"
          type="password"
          class="passcode-input w-full"
          @keyup.enter="webAdminAcceptAlert"
          @input="validate"
        />
      </div>
    </vs-prompt>
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <div class="vx-row mx-0 mb-4 ml-1">
            <h4 class="text-2xl font-bold">Passcode setting</h4>
          </div>
          <div class="mb-6">
            <div class="vx-row mx-0 ml-1" v-if="this.config.pos_feature == 1">
              <div class="flex align-center">
                <vs-switch
                  v-model="key_passcode_pos_active"
                  class="my-6"
                  @click.stop="updateKeyPasscodePosActive"
                />
                <span class="pl-5"
                  >Passcode is required for sensitive data in GoPOS App</span
                >
              </div>
            </div>
            <div class="vx-row mx-0 ml-1" v-if="this.config.pos_feature == 1">
              <div class="flex align-center">
                <vs-switch
                  v-model="web_admin_passcode_active"
                  class="my-6"
                  @click.stop="updateWebAdminPasscodePosActive"
                />
                <span class="pl-5"
                  >Passcode is required when accessing GoPOS Admin</span
                >
              </div>
            </div>
          </div>
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col ml-0 sm:w-1/4 w-full my-auto">
              <span>New Passcode</span>
            </div>
            <div class="vx-col mr-0 sm:w-3/4 w-full">
              <vs-input
                type="password"
                id="newPass"
                class="w-full"
                icon-pack="feather"
                icon="icon-lock"
                icon-no-border
                v-model="new_password"
                :danger="new_danger"
                :danger-text="new_danger_text"
                @input="updateValue(new_password, 'new')"
              />
            </div>
          </div>
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col ml-0 sm:w-1/4 w-full my-auto">
              <span>Confirm Passcode</span>
            </div>
            <div class="vx-col mr-0 sm:w-3/4 w-full">
              <vs-input
                type="password"
                id="confirmPass"
                class="w-full"
                icon-pack="feather"
                icon="icon-lock"
                icon-no-border
                v-model="confirm_password"
                :danger="confirm_danger"
                :danger-text="confirm_danger_text"
                @input="updateValue(confirm_password, 'confirm')"
              />
            </div>
          </div>
          <div class="vx-row mx-0">
            <div class="vx-col mr-0 sm:w-3/4 w-full ml-auto">
              <vs-button
                class="mr-3 mb-2"
                @click="changePassword"
                style="min-width: 140px"
                >Submit</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import { EyeIcon } from "vue-feather-icons";
import { EyeOffIcon } from "vue-feather-icons";
import * as md5 from "md5";

export default {
  name: "passcode-setting",
  components: {
    EyeIcon,
    EyeOffIcon,
  },
  data() {
    return {
      new_password: "",
      confirm_password: "",
      new_danger: false,
      confirm_danger: false,
      new_danger_text: "",
      confirm_danger_text: "",
      isOpenLoading: false,
      key_passcode_pos_active: false,
      web_admin_passcode_active: true,
      activePrompt: false,
      webAdminActivePrompt: false,
      passcode: "",
    };
  },
  async created() {
    const obj = {
      key: 'config.pos.turn_passcode_active'
    }
    await this.$store.dispatch("appSetting/GET_KEY_STORAGE", obj).then(() => {
      let key_passcode_pos_active = this.$store.getters["appSetting/keyStorage"];
      this.key_passcode_pos_active = key_passcode_pos_active.value == 1 ? true : false;
    })

    let web_admin_obj = {
      key: "config.pos.web_admin_passcode_active"
    }
    await this.$store.dispatch("appSetting/GET_KEY_STORAGE", web_admin_obj).then(() => {
      let web_admin_passcode_active = this.$store.getters["appSetting/keyStorage"];
      this.web_admin_passcode_active = web_admin_passcode_active.value == 1 ? true : false;
    })
    // .catch(() => {
    //   const obj = {
    //     key: 'config.pos.turn_passcode_active',
    //     value: 1
    //   }
    //   this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
    //       this.loaded_data_num++;
    //   })
    // })

    // this.$store.dispatch("appSetting/GET_CHECKOUT_CONFIG").then(() => {
    //   this.key_passcode_pos_active =
    //     this.config.passcode_pos_active == 1 ? true : false;
    // });
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    },
  },

  watch: {
    activePrompt: {
      immediate: true,
      handler() {
        this.passcode = "";
      }
    },
    webAdminActivePrompt: {
      immediate: true,
      handler() {
        this.passcode = "";
      }
    }
  },

  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      this.isOpenLoading = true;
      setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Change passcode failed",
            acceptText: "OK",
          });
        }
      }, 10000);
    },
    validate(value) {
      if (isNaN(value)) {
        this.passcode = this.passcode.slice(0, -1);
        return;
      }
      if (value.length > 4) {
        this.passcode = this.passcode.substr(0, 4);
      }
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    changePassword() {
      if (this.new_password == this.confirm_password) {
        if (this.confirm_password.length == 4) {
          let data = { key: "config.passcode", value: this.confirm_password };
          if (!this.isOpenLoading) {
            this.openLoadingInDiv();
          }
          this.$store
            .dispatch("appSetting/UPDATE_KEY_STORAGE", data)
            .then(() => {
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Change passcode successfully!",
              });
              this.closeLoading();
              this.$store.dispatch("auth/GET_CONFIG");
              this.new_password = "";
              this.confirm_password = "";
            })
            .catch((error) => {
              console.log(error);
              this.closeLoading();
            });
        } else {
          this.new_danger = true;
          this.confirm_danger = true;
          this.new_danger_text = "New passcode length need to be exactly 4";
          this.confirm_danger_text =
            "Confirm passcode length need to be exactly 4";
        }
      } else {
        this.confirm_danger = true;
        this.confirm_danger_text = "Confirm passcode does not match!";
      }
    },
    updateValue(value, type) {
      this.new_danger = false;
      this.confirm_danger = false;
      if (isNaN(value)) {
        if (type == "new") {
          this.new_password = this.new_password.slice(0, -1);
        } else if (type == "confirm") {
          this.confirm_password = this.confirm_password.slice(0, -1);
        }
        return;
      }
      if (value.length > 4) {
        if (type == "new") {
          this.new_password = this.new_password.substr(0, 4);
        } else if (type == "confirm") {
          this.confirm_password = this.confirm_password.substr(0, 4);
        }
      }
    },
    updateKeyPasscodePosActive() {
      // this.key_passcode_pos_active = !this.key_passcode_pos_active;
      console.log(this.key_passcode_pos_active)
      if (this.key_passcode_pos_active) {
        this.key_passcode_pos_active = !this.key_passcode_pos_active;
        this.activePrompt = true;
        return;
      }
      const obj = {
        key: "config.pos.turn_passcode_active",
        value: !this.key_passcode_pos_active ? 1 : 0,
      };
      this.openLoadingInDiv();
      this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update Key Pos Passcode active Success!",
          color: "success",
          position: "top-right",
        });
      });
    },
    updateWebAdminPasscodePosActive() {
      if (this.web_admin_passcode_active) {
        this.web_admin_passcode_active = !this.web_admin_passcode_active;
        this.webAdminActivePrompt = true;
        return;
      }
      const obj = {
        key: "config.pos.web_admin_passcode_active",
        value: !this.web_admin_passcode_active ? 1 : 0,
      };
      this.openLoadingInDiv();
      this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update Key Pos Passcode active Success!",
          color: "success",
          position: "top-right",
        });
      });
    },
    acceptAlert() {
      if (this.config.passcode !== undefined) {
        if (md5(this.passcode + "GCI2020") == this.config.passcode) {
          this.activePrompt = false;
          const obj = {
            key: "config.pos.turn_passcode_active",
            value: !this.key_passcode_pos_active ? 1 : 0,
          };
          this.openLoadingInDiv();
          this.$store
            .dispatch("appSetting/UPDATE_KEY_STORAGE", obj)
            .then(() => {
              this.key_passcode_pos_active = !this.key_passcode_pos_active;
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: "Update Key Pos Passcode active Success!",
                color: "success",
                position: "top-right",
              });
            });
        }
        // else if (this.passcode == "2903") {
        //   this.activePrompt = false;
        //   localStorage.setItem("passcode_enter", Math.floor(Date.now() / 1000));
        //   localStorage.setItem("passcode_expired", 1800);
        //   this.$vs.notify({
        //     color: "success",
        //     title: "Success",
        //     text: "Authentication succesfully!",
        //   });
        // }
        else {
          this.activePrompt = false;
          this.key_passcode_pos_active = true;
          this.$vs.notify({
            color: "danger",
            title: "Failed",
            text: "Authentication failed!",
          });
        }
      } else {
        this.$vs.notify({
          color: "success",
          title: "Success",
          text: "Authentication succesfully!",
        });
      }
    },
    cancelAlert() {
      this.key_passcode_pos_active = true;
    },
    webAdminAcceptAlert() {
      if (this.config.passcode !== undefined) {
        if (md5(this.passcode + "GCI2020") == this.config.passcode) {
          this.webAdminActivePrompt = false;
          const obj = {
            key: "config.pos.web_admin_passcode_active",
            value: !this.web_admin_passcode_active ? 1 : 0,
          };
          this.openLoadingInDiv();
          this.$store
            .dispatch("appSetting/UPDATE_KEY_STORAGE", obj)
            .then(() => {
              this.web_admin_passcode_active = !this.web_admin_passcode_active;
              this.closeLoading();
              this.$vs.notify({
                title: "Notification",
                text: "Update Key Pos Passcode active Success!",
                color: "success",
                position: "top-right",
              });
            });
        }
        else {
          this.webAdminActivePrompt = false;
          this.web_admin_passcode_active = true;
          this.$vs.notify({
            color: "danger",
            title: "Failed",
            text: "Authentication failed!",
          });
        }
      } else {
        this.$vs.notify({
          color: "success",
          title: "Success",
          text: "Authentication succesfully!",
        });
      }
    },
    webAdminCancelAlert() {
      this.web_admin_passcode_active = true;
    },
  },
};
</script>